import { useEffect, useState } from 'react';

const useIsInIFrame = (): boolean => {
  const [isInIFrame, setIsInIFrame] = useState(false);

  useEffect(() => {
    setIsInIFrame(window.self !== window.top);
  }, []);

  return isInIFrame;
};

export default useIsInIFrame;
